import { Nav, Navbar } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import classNames from 'classnames';
import NavbarBrand from 'components/navbars/nav-items/NavbarBrand';
import ThemeToggler from 'components/common/ThemeToggler';

const NavbarLogic = () => {
  const {
    config: { navbarTopAppearance }
  } = useAppContext();

  return (
    <Navbar
      className={classNames('navbar-top fixed-top')}
      expand
      variant=""
      data-navbar-appearance={navbarTopAppearance === 'darker' ? 'darker' : ''}
    >
      <div className="navbar-collapse justify-content-between">
        <NavbarBrand />
        <div className="navbar-nav navbar-nav-icons flex-row">
          <Nav.Item>
            <ThemeToggler className="px-2" />
          </Nav.Item>
        </div>
      </div>
    </Navbar>
  );
};

export default NavbarLogic;
